import { render, staticRenderFns } from "./FormSidebarBtn.vue?vue&type=template&id=a4f3b90a"
import script from "./FormSidebarBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSidebarBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports